import * as angular from "angular";
import {IController} from "angular";

export class PlanningProjectsTableCtrl implements IController {

  infiniteScroll: any;
  onDelete: Function;

  /* @ngInject */
  constructor() {
  }

  // ******************************
  //        Public methods
  // ******************************

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectsTable', {
    bindings: {
      infiniteScroll: '<',
      onDelete: '&'
    },
    template: require('./planning-projects-table.html').default,
    controller: PlanningProjectsTableCtrl
  });
